var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTzIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2789 38.9621L58.4362 32.7027L59.2176 30.7328L51.4856 28.0637L49.4383 27.9839L38.2773 31.4392L38.2789 38.9621Z",
    fill: "url(#paint0_linear_18819_22791)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9387 38.8822L0.781418 32.6229L0 30.653L7.73197 27.9839H9.7793L20.9411 31.4392L20.9387 38.8822Z",
    fill: "url(#paint1_linear_18819_22791)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0456 0L23.4492 1.51894V40H35.8482V1.51894L34.2518 0H25.0456Z",
    fill: "url(#paint2_linear_18819_22791)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18819_22791",
    x1: 42.8533,
    y1: 41.6032,
    x2: 51.6516,
    y2: 26.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18819_22791",
    x1: 8.97633,
    y1: 37.3545,
    x2: 14.5285,
    y2: 27.7372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F01642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EE194D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EC1F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E82778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E43198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#DF3DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18819_22791",
    x1: 19.7672,
    y1: 37.8736,
    x2: 39.7888,
    y2: 3.19671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E92571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E43199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E03AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE40C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DD42CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTzIcon);
export default __webpack_public_path__ + "static/media/TZIcon.9ef81dbdae2ada109f9b1b0e76b96aca.svg";
export { ForwardRef as ReactComponent };